/**
 * The toast after creating a user, from POST /users:
 * credentialsEmail sent | failed | not-configured | skipped; temporaryPassword
 * only when a generated password could not be emailed.
 */
export const credentialsNotice = (
  { credentialsEmail, temporaryPassword } = {},
  address,
) => {
  if (credentialsEmail === "sent")
    return { tone: "success", text: `Login details emailed to ${address}.` };
  if (credentialsEmail === "skipped")
    return {
      tone: "success",
      text: temporaryPassword
        ? "User saved. Copy the temporary password and pass it on."
        : "User saved. Login details were not emailed.",
    };
  const reason =
    credentialsEmail === "not-configured"
      ? "email isn't set up on the server"
      : "the email could not be sent";
  return {
    tone: "warning",
    text: `User saved, but ${reason}. ${
      temporaryPassword
        ? "Copy the temporary password and pass it on."
        : "Give them the password you entered."
    }`,
  };
};
